import styled from 'styled-components';

export const Wrapper = styled.div`
    height: 100%;
    padding: 0px 10px;
`;

export const Content = styled.div`
    padding: 10px 0px;
    height: ${(props) => (props.height ? props.height + 'px' : '100%')};
    overflow-y: auto;
    overflow-x: hidden;
`;
